function openBeerTab(evt, index) {
    evt.preventDefault();
    
    var tabsList = document.querySelectorAll('.c-beer-list__tab-link')
    var tabPanels = document.querySelectorAll('.js-beer-tab-panel')
    for (var i = 0; i < tabsList.length; i++){
        tabsList[i].classList.remove('is-active')
        tabPanels[i].classList.remove('is-active')
        tabPanels[i].attributes['aria-hidden'] = 'true'
    }
    tabsList[+index].classList.add('is-active')
    tabPanels[+index].classList.add('is-active')
    tabPanels[+index].attributes['aria-hidden'] = 'false'

  }
  if (document.querySelector('.js-location-fav-button')) {
    document.querySelector('.js-location-fav-button').addEventListener('click', function(evt){
        var id = evt.target.dataset.id
        window.App.myLocation.update(id)
        evt.target.classList.add('is-active')
    })
  }


var now = new Date(Date.now()); //get current date
var day = now.getDay() - 1; // get the day and offset it
if (day < 0) { day = 6 } // if today is sunday (0 minus 1), set it to 6
if (document.querySelectorAll('.c-location-hours__list-item').length != 0) {
    document.querySelectorAll('.c-location-hours__list-item')[day].classList.add('is-active'); // add the active class to the current day

 
}
